<template>
  <v-container fluid grid-list-xl>
    <v-flex xs8 offset-xs2>
      <v-card>
        <v-container>
          <h1 class="display-1">JSON File Upload</h1>
          <v-textarea label="Paste JSON here" v-model="upload"></v-textarea>
          <v-btn :loading="loading" :disabled="loading" color="primary" class="white--text" @click="uploadCustomers()">
          Upload
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
        </v-container>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
import CustomerService from '@/services/CustomerService'
export default {
  data () {
    return {
      loading: false,
      upload: null
    }
  },
  methods: {
    uploadCustomers () {
      this.loading = true

      try {
        var json = JSON.parse(this.upload)
      } catch (error) {
        console.log('Failed to parse JSON')
        this.upload = null
        this.loading = false
        return
      }

      json.forEach(async function (customer, index) {
        const customerResponse = await CustomerService.addCustomer({
          firstName: customer.first_name,
          lastName: customer.last_name,
          email: customer.cust_email,
          phone: customer.phone_no,
          newsletter: false
        })

        if (customerResponse.success) {
          if (index + 1 === json.length) {
            this.upload = null
            this.loading = false
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/import/Customers.vue